module.exports = __webpack_public_path__ + "Lato-Regular.3b9b99039cc0a98dd50c.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/hrushabhmakwana/Documents/CAM/CreditRepairMenAngular/src/assets/font/Lato-Regular.ttf
// module id = ../../../../../src/assets/font/Lato-Regular.ttf
// module chunks = styles